import Icon from '../components/Icon.vue'

Icon.register({
  ruler: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M635.7 167.2L556.1 31.7C547.3 16.7 527.8 11.6 512.6 20.2L443.6 59.3 503.3 161C505.5 164.8 504.2 169.5 500.4 171.7L486.6 179.5C482.8 181.7 477.9 180.4 475.7 176.6L416 75 360.8 106.3 388.7 153.7C390.9 157.5 389.6 162.2 385.8 164.4L372 172.2C368.2 174.4 363.3 173.1 361.1 169.3L333.2 122 278 153.3 337.8 255C340 258.7 338.7 263.5 334.9 265.7L321.1 273.5C317.3 275.7 312.4 274.4 310.2 270.6L250.5 168.9 195.3 200.2 223.2 247.6C225.4 251.4 224.1 256.1 220.3 258.3L206.5 266.1C202.7 268.3 197.8 267 195.6 263.2L167.7 215.7 112.5 247 172.2 348.7C174.4 352.4 173.1 357.2 169.3 359.4L155.5 367.2C151.7 369.4 146.8 368.1 144.6 364.3L84.9 262.9 15.9 302C0.7 310.7-4.6 329.8 4.2 344.8L83.8 480.4C92.6 495.4 112.1 500.5 127.3 491.9L624.1 210C639.3 201.4 644.5 182.2 635.7 167.2z'
      }
    ]
  }
})
